type Props = {
  viewMode: 'active' | 'archived'
}

export const ApplicationsEmptyState = ({ viewMode }: Props) => (
  <div className="flex flex-col items-center justify-center py-16 px-4">
    <div className="w-20 h-20 mb-6 rounded-2xl bg-app-surface/50 flex items-center justify-center">
      {viewMode === 'archived' ? (
        <svg
          className="w-10 h-10 text-app-muted"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
          />
        </svg>
      ) : (
        <svg
          className="w-10 h-10 text-app-muted"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      )}
    </div>
    <h3 className="text-lg font-semibold text-app-muted mb-2 font-display">
      {viewMode === 'archived' ? 'No archived applications' : 'No applications yet'}
    </h3>
    <p className="text-sm text-app-muted text-center max-w-sm mb-6">
      {viewMode === 'archived'
        ? 'Applications you archive will appear here. Archive items you no longer need to track actively.'
        : 'Start tracking your job search by adding your first application. Paste a job posting URL to get started.'}
    </p>
    {viewMode === 'active' && (
      <div className="flex items-center gap-2 text-sm text-app-muted">
        <span className="inline-flex items-center gap-1.5 rounded-lg border border-dashed border-app-line px-3 py-2">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          Add application above
        </span>
      </div>
    )}
  </div>
)
